import * as React from "react";
import Moment from 'react-moment';
import 'whatwg-fetch';
import Select from 'react-select'

class Users extends React.Component<any,any> {
    newCollaboratorEmail:any
    clearButton:any
    renderUser(user) {
        let userName;
        if(user.name) {
            userName = user.name + " (" + user.email + ")";
        } else {
            userName = user.email;
        }

        let avatar;
        if (user.image_src) {
            avatar = <img alt="" className="user-image" src={user.image_src} />;
        } else {
            avatar = "";
        }
        let lastMessage;
        let messageCount = this.props.messages.reduce((acc,message) => {
            if(message.senderId === user.id)  {
                lastMessage = message;
                return (acc + 1);
            } else {
                return acc;
            }
        },0);
        let lastMessageDate;
        if(lastMessage) {
            lastMessageDate =
                <div className="user-info">
                    Last message: &nbsp;
                    <Moment format="DD/MM/YYYY HH:mm:ss">
                        {lastMessage.createdAt}
                    </Moment>
                </div>;
        }
        let userUrl;

        const contactDocument = this.props.contacts[user.id];
        if (contactDocument) {
            userUrl = "/en/edit-document/" + contactDocument;
        } else {
            userUrl = "/documents/user/" + user.id + ".html";
        }

        let isMineDocument = (this.props.currentUser.id === this.props.document.user_id) ? true : false;
        let isMe = (this.props.currentUser.id === user.id) ? true : false;

        let removeCollaborator;
        if (isMineDocument && !isMe) {
            removeCollaborator = <div><a onClick={(e) => this.removeCollaborator(user.id)} className="deleteMessage" href="#">Remove collaborator</a></div>;
        };
        return (
            <div className="user-container" key={user.id}>
                <div className="user">
                    {avatar}
                    <span><a rel="noopener noreferrer" target="_blank" href={userUrl}>{userName}</a></span>
                    <div className="user-info">Messages: {messageCount} </div>
                    {lastMessageDate}
                    {removeCollaborator}
                </div>
            </div>
        )
    }
    removeCollaborator(userId) {
        const res = window.confirm("Are you sure want to remove the user from the collaborators list?");
        if (res) {
            fetch("/documents/"+this.props.document.id+"/unshare/"+userId,{credentials: "same-origin",method: 'POST'})
                .then((response) => response.json())
                .then((json) =>  {
                    window.location.reload();
                })
                .catch((error) => {
                    console.log(error);
                    alert("Error while removing collaborator: "+error);
                });
            }
    }
    addCollaborator(collaborator) {
        fetch("/documents/"+this.props.document.id+"/share_to_email/"+collaborator.label,{credentials: "same-origin",method: 'POST'})
            .then((response) => response.json())
            .then((json) =>  {
                if (json.error) {
                    alert(json.error);
                } else {
                    window.location.reload();
                }
            })
            .catch((result) => {
                if(result.responseJSON && result.responseJSON.error) {
                    alert(result.responseJSON.error);
                } else {
                    alert(JSON.stringify(result));
                }
            });
    }
    render() {
        //console.log(this.props.collaborators);
        const {users} = this.props;

        let usersInfo: any[] = [];

        for (let userId in users) {
            if (users.hasOwnProperty(userId)) {
                usersInfo.push(users[userId]);
            }
        }

        let options: any[] = [];

        this.props.collaborators.forEach((c) => options.push({
            "values": c[0].email,
            "label": c[0].email,
        }));

        let isMineDocument = (this.props.currentUser.id === this.props.document.user_id) ? true : false;

        let addCollaboratorHtml;
        if(isMineDocument) {
            addCollaboratorHtml = <div className="new-collaborator-form-container">
                <div>Add collaborator</div>
                <form>
                <div style={{width: '100%'}}>
                <Select options={options} placeholder="Email" onChange={this.addCollaborator.bind(this)}/>
                 </div>
                </form>
                </div>;
        };

        return (
            <div className="header">
                <div>
                    {usersInfo.map((user) => this.renderUser(user))}
                </div>
                {addCollaboratorHtml}
            </div>
        );
    }
}

export default Users;
